// The Christmas walk — one ready-made winter route shared by /christmas,
// /christmas-walk and mirrored in the planner as the XMAS_WALK one-tap fill
// (durations mirror the spot durations in data/planner.js).
const SITE = "https://cphhighlights.com";

export const CHRISTMAS_WALK_ROUTE = [
  // market stops query the squares themselves — Google's market listing still
  // points at last year's Højbro Plads spot
  { name: "Nyhavn Christmas Market", street: "Nyhavn", durText: "1h", q: "Nyhavn, København", coords: [55.6799, 12.5913] },
  { name: "Kongens Nytorv Christmas Market", street: "Kongens Nytorv", durText: "30 min", q: "Kongens Nytorv, København", coords: [55.6805, 12.5851] },
  { name: "d'Angleterre's Christmas facade", street: "Kongens Nytorv 34", durText: "5 min", q: "Hotel d'Angleterre, Kongens Nytorv 34, København", coords: [55.6795, 12.5864] },
  { name: "Hviids Vinstue — the gløgg stop", street: "Kongens Nytorv 19", durText: "30 min", q: "Hviids Vinstue, Kongens Nytorv 19, København", coords: [55.6798, 12.5855] },
  { name: "Jul på Højbro Plads", street: "Højbro Plads", durText: "30 min", q: "Højbro Plads, København", coords: [55.6779, 12.5802] },
  { name: "Gammel Torv Christmas Market", street: "Gammel Torv", durText: "30 min", q: "Gammel Torv, København", coords: [55.6781, 12.5722] },
  { name: "Rådhuspladsen Christmas Market", street: "Rådhuspladsen", durText: "30 min", q: "Rådhuspladsen, 1599 København", coords: [55.6759, 12.5701] },
  { name: "Jul i Tivoli", street: "Vesterbrogade 3", durText: "the evening", coords: [55.6737, 12.5681] },
];

const walkQ = (s) => encodeURIComponent(s.q || `${s.name}, ${s.street}, Copenhagen`);

export const christmasWalkUrl = (stops) =>
  `https://www.google.com/maps/dir/?api=1&origin=${walkQ(stops[0])}&destination=${walkQ(stops[stops.length - 1])}&waypoints=${stops.slice(1, -1).map(walkQ).join("%7C")}&travelmode=walking`;

export const CHRISTMAS_WALK_ITEMLIST = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "The Christmas walk — a ready-made Copenhagen Christmas route",
  description:
    "Nyhavn's Christmas market, the Kongens Nytorv market, d'Angleterre's facade, gløgg at Hviids Vinstue (1723), the Gammel Torv and Rådhuspladsen markets, and Jul i Tivoli — about 2.5 km on foot.",
  itemListElement: CHRISTMAS_WALK_ROUTE.map((s, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: `${s.name}, ${s.street}, Copenhagen`,
    url: `${SITE}/christmas-walk`,
  })),
};
